import moment from 'moment';

const DATE_FORMAT = 'Do MMM yyyy';

export const formatDate = (dateString: string): string => moment(dateString).format(DATE_FORMAT);
